import { InjectionToken } from "@angular/core";

export const IS_MOBILE_AGENT = new InjectionToken<boolean>('IS_MOBILE_AGENT');